module.exports = __webpack_public_path__ + "img/IMG_2223.c00db324.jpg";